import styled from 'styled-components';
import { ReactComponent as LogoIcon } from 'styles/icons/logo.svg';

export const InnerFormHolderTop = styled.div`
  > div > div {
    width: auto;
    > input {
      width: auto;
    }
  }
`;

export const HeaderStyledLogoIcon = styled(LogoIcon)`
  position: relative;
`;
